import http from '../httpService';

export function createCreditRiskManagementForm(payload) {
  return http.post('/credit-risk-management-forms',payload);
}

export function editCreditRiskManagementForm(id,payload) {
  return http.put(`/credit-risk-management-forms/${id}`,payload)
}

export function getCreditRiskManagementForm(id) {
  return http.get(`/credit-risk-management-forms?cycleId.equals=${id}`)
}
export function getCreditRiskManagementOverallRiskAssessmentLevels() {
  return http.get(`/credit-risk-management-overall-risk-assessment-levels`)
}